import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Axis of symmetry feature parameters */
export interface AxisOfSymmetryParams {
  /** Reference to parent function element */
  of: string;
  /** Explicit x-value for axis (overrides auto-detection) */
  x?: number;
  /** For periodic functions: how many axes to show (default: 1) */
  count?: number;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** Default parameters for axis of symmetry */
export const AXIS_OF_SYMMETRY_DEFAULT_PARAMS: Omit<AxisOfSymmetryParams, 'of'> = {
  count: 1,
};

/**
 * Default theme for axis of symmetry feature.
 * Dashed vertical line.
 */
export const AXIS_OF_SYMMETRY_DEFAULTS: FeatureStyleNode = {
  line: { color: 'neutral', strokeWidth: 2, dash: 3 },
};
